import { Link } from '../../../lib/compatibility';

export default function Footer() {
  return (
    <footer className="bg-gray-900 text-gray-300 pt-20 pb-10">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-12 mb-16">
          <div>
            <Link href="/" className="flex items-center mb-6">
              <div className="relative flex items-center">
                <img 
                  src="/logo-iaexpertos.svg" 
                  alt="AGENTS AI" 
                  className="h-16 w-16 mr-3"
                  onError={(e) => {
                    const target = e.target as HTMLImageElement;
                    target.onerror = null;
                    target.src = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1MTIgNTEyIj48IS0tIEZhIEJyYWluIC0tPjxwYXRoIGZpbGw9IiNmZmYiIGQ9Ik0xODQuMiAzNS4zQzE5MyAyMS43IDIxMC40IDE2IDIyNyAxNmM0MyAwIDY4LjIgMzUuOSA3MSA0MSzIgLjggMS4zIDEgMi44IDEgNC4zdjREMzMxIDI3IE0zNjQgMTZjMzcuOSAwIDcwLjcgMjAuOSA4Ny4yIDUxLjRjMy40IDE1LjggNS4yIDMyLjQgNS4yIDQ5LjEgMCAxOS40LTUuMyAxOS43LTE2IDEyMGMwIDMyLjgtMjcuNCA1OS41LTYwLjUgNTkuNWMtOS43IDAtMTktMy4xLTI2LjgtOC45Yy0yNC44LTE4LjEtMzguMyA1LjQtOTEuNyA1LjRzLTY2LjktMjMuNS05MS43LTUuNC00OS41LTFjLTMzLjEgMC02MC41LTI2LjctNjAuNS01OS41YzAtMTAwLjMtMTYtMTAwLjYtMTYtMTIwYzAtMTQgMS4xLTI3LjUgMy4yLTQwLjUgMzItOS4xIDYwLjgtMzEuMSA3Mi44LTU4LjheiIvPjwvc3ZnPg==";
                  }}
                />
                <div className="flex flex-col">
                  <span className="text-white text-xl font-bold leading-tight">AGENTS</span>
                  <span className="text-secondary text-2xl font-extrabold leading-tight tracking-wide">AI</span>
                </div>
              </div>
            </Link>
            <p className="mb-6 text-gray-300 leading-relaxed">Especialistas en soluciones de inteligencia artificial para empresas y profesionales. Transformamos ideas en realidad con tecnología de vanguardia.</p>
            
            {/* Company Information */}
            <div className="mb-6 text-gray-300">
              <div style={{ fontSize: '16px', fontWeight: 'normal', marginBottom: '8px' }}>AGENTS AI Limited</div>
              <div style={{ fontSize: '12px', fontStyle: 'italic', opacity: '0.7', lineHeight: '1.4' }}>
                27 Old Gloucester Street<br/>
                London WC1N 3AX<br/>
                UK<br/>
                Register Number: 16570822
              </div>
            </div>
            
            <div className="flex space-x-5">
              <a href="mailto:info@pime.ai" className="text-gray-300 hover:text-white transition duration-300 bg-gray-800 hover:bg-gray-700 w-10 h-10 rounded-full flex items-center justify-center">
                <i className="fas fa-envelope"></i>
              </a>
              <a href="https://linkedin.com/company/agents-ai-limited" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-white transition duration-300 bg-gray-800 hover:bg-gray-700 w-10 h-10 rounded-full flex items-center justify-center">
                <i className="fab fa-linkedin"></i>
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-xl font-semibold text-white mb-6">Servicios</h3>
            <ul className="space-y-4">
              <li><Link href="/servicios/clases-particulares-ia" className="hover:text-white transition duration-300">Clases Particulares de IA</Link></li>
              <li><Link href="/servicios/ia-sin-programacion" className="hover:text-white transition duration-300">IA sin Programación</Link></li>
              <li><Link href="/servicios/apoyo-academico-ia-ml" className="hover:text-white transition duration-300">Apoyo Académico IA</Link></li>
              <li><Link href="/servicios/desarrollo-apps-vision-artificial" className="hover:text-white transition duration-300">Desarrollo de Apps AI</Link></li>
              <li><Link href="/servicios/ia-para-creativos-marketing" className="hover:text-white transition duration-300">IA para Creativos</Link></li>
              <li><Link href="/servicios/ia-para-negocios" className="hover:text-white transition duration-300 flex items-center">
                <span className="w-2 h-2 rounded-full bg-yellow-500 mr-2"></span>
                IA para Negocios
              </Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-xl font-semibold text-white mb-6">Formación</h3>
            <ul className="space-y-4">
              <li><Link href="/cursos/fundamentos-ia" className="hover:text-white transition duration-300">Fundamentos de IA</Link></li>
              <li><Link href="/cursos/machine-learning-avanzado" className="hover:text-white transition duration-300">Machine Learning Avanzado</Link></li>
              <li><Link href="/cursos/nlp-con-transformers" className="hover:text-white transition duration-300">NLP con Transformers</Link></li>
              <li><Link href="/cursos/ia-generativa" className="hover:text-white transition duration-300">IA Generativa</Link></li>
              <li><Link href="/cursos/implementacion-gpt4" className="hover:text-white transition duration-300">Implementación de IA Avanzada</Link></li>
              <li><Link href="/cursos/analisis-datos-python" className="hover:text-white transition duration-300">Análisis de Datos con Python</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-xl font-semibold text-white mb-6">Enlaces rápidos</h3>
            <ul className="space-y-4">
              <li><Link href="/" className="hover:text-white transition duration-300">Inicio</Link></li>
              <li><Link href="/nosotros" className="hover:text-white transition duration-300">Nosotros</Link></li>
              <li><Link href="/blog" className="hover:text-white transition duration-300">Blog</Link></li>
              <li><Link href="/herramientas-ia" className="hover:text-white transition duration-300">Herramientas IA</Link></li>
              <li><Link href="/recursos" className="hover:text-white transition duration-300">Recursos</Link></li>
              <li><Link href="/precios" className="hover:text-white transition duration-300 inline-flex items-center">
                <span className="w-2 h-2 rounded-full bg-green-500 mr-2"></span>
                <span>Precios</span>
              </Link></li>
              <li><Link href="/contacto" className="hover:text-white transition duration-300 inline-flex items-center">
                <span>Contacto</span>
                <i className="fas fa-arrow-right ml-2 text-xs opacity-75"></i>
              </Link></li>
            </ul>
          </div>
        </div>

        <div className="pt-10 border-t border-gray-800 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400">&copy; {new Date().getFullYear()} AGENTS AI Limited - Todos los derechos reservados</p>
          <div className="flex space-x-8 mt-4 md:mt-0">
            <Link href="/privacidad" className="hover:text-white transition duration-300 text-sm">Política de privacidad</Link>
            <Link href="/terminos" className="hover:text-white transition duration-300 text-sm">Términos y condiciones</Link>
            <Link href="/cookies" className="hover:text-white transition duration-300 text-sm">Cookies</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
